import { render, staticRenderFns } from "./LogoutModal.vue?vue&type=template&id=35c06f25&scoped=true&"
import script from "./LogoutModal.vue?vue&type=script&lang=js&"
export * from "./LogoutModal.vue?vue&type=script&lang=js&"
import style0 from "./LogoutModal.vue?vue&type=style&index=0&id=35c06f25&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c06f25",
  null
  
)

export default component.exports